import type { Location } from '@remix-run/router';
import type { TBranchData, IBranchCreateData } from 'src/types/branch';

import { toast } from 'sonner';
import { useLocation } from 'react-router';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import axiosInstance, { endpoints } from 'src/utils/axios';

import { DashboardContent } from 'src/layouts/dashboard';

import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';

import { BranchNewEditForm } from '../branch-new-edit-form';

export function BranchEditView() {
  const router = useRouter();

  const { state }: Location<TBranchData> = useLocation();

  const handleSubmit = (data: IBranchCreateData) =>
    axiosInstance
      .patch(endpoints.branch.update, { ...data, _id: state._id })
      .then((res) => {
        const { message } = res.data;

        toast.success(message);
        router.push(paths.dashboard.branches.root);
      })
      .catch((error) => {
        toast.error(error.message);
      });

  return (
    <DashboardContent>
      <CustomBreadcrumbs
        heading="Şubeyi Düzenle"
        links={[
          { name: 'Ana Sayfa', href: paths.dashboard.root },
          { name: 'Şubeler', href: paths.dashboard.branches.root },
          { name: 'Şube Düzenleme' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />
      <BranchNewEditForm initialValues={state} onSubmit={handleSubmit} />
    </DashboardContent>
  );
}
